import styled from '@emotion/styled';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';
import { BreakPointToken } from '../../hooks/useMediaQuery';

const {
	color: colours,
	spacing: {
		size_4px: { height: size_4 },
		size_16px: { height: size_16 },
		size_40px: { height: size_40 },
		size_112px: { height: size_112 },
		size_160px: { height: size_160 }
	}
} = tokens;

export const CounterPanel = styled.div<{ noMargin?: boolean }>`
	display: flex;
	justify-content: space-between;
	padding: 0;
	margin-block-start: ${({ noMargin }) => (noMargin ? 0 : `${size_16}px`)};
`;

export const CounterText = styled.div`
	flex: 1;
	@media (min-width: ${BreakPointToken.MdMin}px) {
		min-width: ${size_40 + size_160}px;
	}
	& span {
		color: ${colours.light.text_secondary};
	}
`;

export const Alert = styled.span`
	display: flex;
	align-items: flex-start;
	margin-block-end: ${size_16}px;
	color: ${colours.light.text_error};
	@media (min-width: ${BreakPointToken.MdMin}px) {
		max-width: ${size_112 + size_160}px;
	}

	& span {
		margin-inline-end: ${size_4}px;
	}
`;

export const PassengerField = styled.div`
	position: relative;
`;

export const PassengerInput = styled.div<{ hidden: boolean }>`
	display: ${({ hidden }) => (hidden ? 'none' : 'block')};

	input {
		cursor: pointer;
	}
`;
